import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=3f8b423a"
import script from "./page-container.vue?vue&type=script&lang=js"
export * from "./page-container.vue?vue&type=script&lang=js"
import style0 from "./page-container.vue?vue&type=style&index=0&id=3f8b423a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8b423a')) {
      api.createRecord('3f8b423a', component.options)
    } else {
      api.reload('3f8b423a', component.options)
    }
    module.hot.accept("./page-container.vue?vue&type=template&id=3f8b423a", function () {
      api.rerender('3f8b423a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-container.vue"
export default component.exports